import { useEffect,useState } from "react"
import {format,parse} from 'date-fns'
import axios from "axios"
import uuid from "react-uuid"
export default function EditRegistro({clientes,centros,proyectos,registros,registro,usuarios,user,setRegistros}){
    const [acierto,setAcierto]=useState(false)
    const [inicio,setInicio]=useState(parse(registro.inicio,"dd/MM/yyyy HH:mm:ss",new Date()))
    const [fin,setFin]=useState(registro.fin==null?null:parse(registro.fin,"dd/MM/yyyy HH:mm:ss",new Date()))
    const [descripcion,setDescripcion]=useState(registro.descripcion==null?"":registro.descripcion)
    const [observaciones,setObservaciones]=useState(registro.observaciones==null?"":registro.observaciones)
    const [terminado,setTerminado]=useState(registro.fin!=null)
    function intervalo(str_inicio,str_fin){
            const formato = 'dd/MM/yyyy HH:mm:ss'
            const inicio=parse(str_inicio,formato,new Date())
            const fin=parse(str_fin,formato,new Date())
            return Math.round((fin-inicio)/(36000))/100
        }
    function formatString(date){
        const d = new Date(date)
        const dia = d.getDate().toString().padStart(2, '0');
        const mes = (d.getMonth() + 1).toString().padStart(2, '0');
        const año = d.getFullYear();
        return `${dia}/${mes}/${año}`;
    }
    function getFechaLocal() {
        const fecha = new Date();
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        const hora = String(fecha.getHours()).padStart(2, '0');
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const segundos = String(fecha.getSeconds()).padStart(2, '0');
        return `${anio}-${mes}-${dia}T${hora}:${minutos}:${segundos}`;
    }
    function getFecha(str){
        const fecha = new Date(str);
        const anio = fecha.getFullYear();
        const mes = String(fecha.getMonth() + 1).padStart(2, '0');
        const dia = String(fecha.getDate()).padStart(2, '0');
        const hora = String(fecha.getHours()).padStart(2, '0');
        const minutos = String(fecha.getMinutes()).padStart(2, '0');
        const segundos = String(fecha.getSeconds()).padStart(2, '0');
        return `${anio}-${mes}-${dia}T${hora}:${minutos}:${segundos}`;
    }
    function formatString2(str){
            const d=new Date(str)
            const dia = d.getDate().toString().padStart(2, '0')
            const mes = (d.getMonth() + 1).toString().padStart(2, '0')
            const año = d.getFullYear()
            const hora=d.getHours().toString().padStart(2, '0')
            const min=d.getMinutes().toString().padStart(2, '0')
            const sec=d.getSeconds().toString().padStart(2, '0')
            return `${dia}/${mes}/${año} ${hora}:${min}:${sec}`
    }
    function formatStringReverse(str){
        const d=parse(str,"dd/MM/yyyy HH:mm:ss",new Date())
        const dia = d.getDate().toString().padStart(2, '0')
        const mes = (d.getMonth() + 1).toString().padStart(2, '0')
        const año = d.getFullYear();
        const hora=d.getHours()
        const min=d.getMinutes()
        const sec=d.getSeconds()
        return `${año}/${mes}/${dia} ${hora}:${min}:${sec}`
    }
    const onChange=(event)=>{
        setAcierto(false)
        if (event.target.name=="descripcion"){
            setDescripcion(event.target.value)
        }
        else if (event.target.name=="observaciones"){
            setObservaciones(event.target.value)
        }
        else if (event.target.name=="inicio"){
            if(getFecha(event.target.value)>fin){
                    setInicio(fin)
            }
            else if (new Date(event.target.value)>new Date()){
                setInicio(getFechaLocal())
            }
            else{
                setInicio(getFecha(event.target.value))
            }
        }
        else if (event.target.name=="fin"){
            if(getFecha(event.target.value)<inicio){
                setFin(inicio)
            }
            else if (new Date(event.target.value)>new Date()){
                setFin(getFechaLocal())
            }
            else{
                setFin(getFecha(event.target.value))
            }
        }
    }
    const Click=()=>{
        const nuevo={
            id:registro.id,
            id_proyecto:proyectos.find(p=>p.nombre==registro.proyecto).id,
            inicio:inicio,
            fin:fin,
            descripcion:descripcion.replaceAll(" ","").length>0?descripcion:null,
            observaciones:observaciones.replaceAll(" ","").length>0?observaciones:null,
            id_usuario:usuarios.find(u=>u.nick==registro.usuario).id
        }
        const nuevoccpu={
            id:registro.id,
            cliente:registro.cliente,
            centro:registro.centro,
            proyecto:registro.proyecto,
            usuario:registro.usuario,
            inicio:formatString2(inicio),
            fin:fin==null?null:formatString2(fin),
            descripcion:descripcion.replaceAll(" ","").length>0?descripcion:null,
            observaciones:observaciones.replaceAll(" ","").length>0?observaciones:null
        }
        axios.put("https://www.asinova.es/webapi/api/Registros",nuevo).then(()=>{
            let data=registros.filter(r=>r.id!=nuevoccpu.id)
            data.push(nuevoccpu)
            setRegistros(data.sort((x,y)=>formatStringReverse(y.inicio).localeCompare(formatStringReverse(x.inicio))))
            setAcierto(true)
        })
    }
    return (
        <>
        <div style={{marginBottom:'1rem'}}>
            <h1>EDITAR REGISTRO</h1>
            <p>Cliente: {registro.cliente}</p>
            <p>Centro: {registro.centro}</p>
            <p>Proyecto: {registro.proyecto}</p>
            <input type="text" name="descripcion" id="descripcion" value={descripcion} placeholder="Descripción" onChange={onChange} style={{marginBottom:'1rem'}}/>
            <input type="text" name="observaciones" id="observaciones" value={observaciones} placeholder="Observaciones" onChange={onChange} style={{marginBottom:'1rem'}}/>
            <input type='datetime-local' name="inicio" value={format(inicio,"yyyy-MM-dd HH:mm")} onChange={onChange}/>
            {registro.fin==null?
                <div style={{justifyContent:'center',display:'flex',justifyContent:'center',marginTop:'1rem'}}>
                    <input type='checkbox' id="terminado" name="terminado" value={terminado} onChange={()=>{setFin(!terminado?new Date():null);setTerminado(!terminado)}} style={{color:'gold',margin:0,width:'2rem'}}></input>
                    <label for={'terminado'} style={{color:'gold'}}>Terminado</label>
                </div>
            :null}
            {terminado?
                <input type='datetime-local' name="fin" value={format(fin,"yyyy-MM-dd HH:mm")} onChange={onChange} style={{marginTop:'1rem'}}/>
            :null}
        </div>
        <a className="btn-form" style={{display:'block',margin:'0 auto',width:'fit-content'}} onClick={Click}>Enviar</a>
        {acierto?<p className="aqua" style={{textAlign:'center',marginTop:'1rem'}}><b>Registro editado con éxito</b></p>:null}
        </>
    )    
}